// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { GetWorkspaceSSHKeyResponse, ProvisionWorkspaceSSHKeyResponse } from "../etlSource/dto.generated";
import type { AddMemberResponse, LeavePreview, LeaveResult, ListWorkspaceMembersResponse, ListWorkspaceProjectCountsResponse, ListWorkspacesResponse, MemberIdpSubResponse, MemberRoleResponse, MyPermissionsResponse, PendingWorkspaceInvitationResponse, ReportSettingsResponse, UpdateMemberRoleResponse, WorkspaceMemberResponse, WorkspaceOwnerResponse, WorkspaceProjectCountItem, WorkspaceResponse } from "../workspace/dto.generated";
import type { Permission } from "../workspace/permission.generated";
export const addTagTypes = ["workspaces", "permissions"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiWorkspaces: build.query<
        GetApiWorkspacesApiResponse,
        GetApiWorkspacesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces`,
          params: {
            user_email: queryArg.userEmail,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["workspaces"],
      }),
      postApiWorkspaces: build.mutation<
        PostApiWorkspacesApiResponse,
        PostApiWorkspacesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces`,
          method: "POST",
          body: queryArg.workspaceCreateWorkspaceRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiWorkspacesMe: build.query<
        GetApiWorkspacesMeApiResponse,
        GetApiWorkspacesMeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/me`,
          params: {
            user_email: queryArg.userEmail,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["workspaces"],
      }),
      getApiWorkspacesMeProjectCounts: build.query<
        GetApiWorkspacesMeProjectCountsApiResponse,
        GetApiWorkspacesMeProjectCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/me/project-counts`,
          params: {
            user_email: queryArg.userEmail,
          },
        }),
        providesTags: ["workspaces"],
      }),
      getApiWorkspacesById: build.query<
        GetApiWorkspacesByIdApiResponse,
        GetApiWorkspacesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}`,
        }),
        providesTags: ["workspaces"],
      }),
      deleteApiWorkspacesById: build.mutation<
        DeleteApiWorkspacesByIdApiResponse,
        DeleteApiWorkspacesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["workspaces"],
      }),
      patchApiWorkspacesById: build.mutation<
        PatchApiWorkspacesByIdApiResponse,
        PatchApiWorkspacesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}`,
          method: "PATCH",
          body: queryArg.workspaceUpdateWorkspaceRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiWorkspacesByIdInvitations: build.query<
        GetApiWorkspacesByIdInvitationsApiResponse,
        GetApiWorkspacesByIdInvitationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/invitations`,
        }),
        providesTags: ["workspaces"],
      }),
      deleteApiWorkspacesByIdInvitationsAndInvitationId: build.mutation<
        DeleteApiWorkspacesByIdInvitationsAndInvitationIdApiResponse,
        DeleteApiWorkspacesByIdInvitationsAndInvitationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/invitations/${encodeURIComponent(String(queryArg.invitationId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["workspaces"],
      }),
      postApiWorkspacesByIdLeave: build.mutation<
        PostApiWorkspacesByIdLeaveApiResponse,
        PostApiWorkspacesByIdLeaveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/leave`,
          method: "POST",
          body: queryArg.workspaceLeaveRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiWorkspacesByIdLeavePreview: build.query<
        GetApiWorkspacesByIdLeavePreviewApiResponse,
        GetApiWorkspacesByIdLeavePreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/leave-preview`,
        }),
        providesTags: ["workspaces"],
      }),
      getApiWorkspacesByIdMembers: build.query<
        GetApiWorkspacesByIdMembersApiResponse,
        GetApiWorkspacesByIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/members`,
          params: {
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["workspaces"],
      }),
      postApiWorkspacesByIdMembers: build.mutation<
        PostApiWorkspacesByIdMembersApiResponse,
        PostApiWorkspacesByIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/members`,
          method: "POST",
          body: queryArg.workspaceAddMemberRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      workspaceGetMembersIdpSubs: build.query<
        WorkspaceGetMembersIdpSubsApiResponse,
        WorkspaceGetMembersIdpSubsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/members/idp-subs`,
        }),
        providesTags: ["workspaces"],
      }),
      deleteApiWorkspacesByIdMembersAndUserId: build.mutation<
        DeleteApiWorkspacesByIdMembersAndUserIdApiResponse,
        DeleteApiWorkspacesByIdMembersAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/members/${encodeURIComponent(String(queryArg.userId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiWorkspacesByIdMembersAndUserIdRole: build.query<
        GetApiWorkspacesByIdMembersAndUserIdRoleApiResponse,
        GetApiWorkspacesByIdMembersAndUserIdRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/members/${encodeURIComponent(String(queryArg.userId))}/role`,
        }),
        providesTags: ["workspaces"],
      }),
      patchApiWorkspacesByIdMembersAndUserIdRole: build.mutation<
        PatchApiWorkspacesByIdMembersAndUserIdRoleApiResponse,
        PatchApiWorkspacesByIdMembersAndUserIdRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/members/${encodeURIComponent(String(queryArg.userId))}/role`,
          method: "PATCH",
          body: queryArg.workspaceUpdateWorkspaceMemberRoleRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiWorkspacesByIdOwner: build.query<
        GetApiWorkspacesByIdOwnerApiResponse,
        GetApiWorkspacesByIdOwnerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/owner`,
        }),
        providesTags: ["workspaces"],
      }),
      getApiWorkspacesByIdPermissions: build.query<
        GetApiWorkspacesByIdPermissionsApiResponse,
        GetApiWorkspacesByIdPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/permissions`,
        }),
        providesTags: ["permissions"],
      }),
      getApiWorkspacesByIdSshKey: build.query<
        GetApiWorkspacesByIdSshKeyApiResponse,
        GetApiWorkspacesByIdSshKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/ssh-key`,
        }),
        providesTags: ["workspaces"],
      }),
      postApiWorkspacesByIdSshKey: build.mutation<
        PostApiWorkspacesByIdSshKeyApiResponse,
        PostApiWorkspacesByIdSshKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/ssh-key`,
          method: "POST",
        }),
        invalidatesTags: ["workspaces"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as workspaceApi };
export type GetApiWorkspacesApiResponse = /** status 200 OK */ { data: WorkspaceListWorkspacesResponse };
export type GetApiWorkspacesApiArg = {
  /** User email. Used when auth claims are unavailable */
  userEmail?: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type PostApiWorkspacesApiResponse =
  /** status 201 Created */ { data: WorkspaceWorkspaceResponse };
export type PostApiWorkspacesApiArg = {
  /** Workspace creation request */
  workspaceCreateWorkspaceRequest: WorkspaceCreateWorkspaceRequest;
};
export type GetApiWorkspacesMeApiResponse =
  /** status 200 OK */ { data: WorkspaceListWorkspacesResponse };
export type GetApiWorkspacesMeApiArg = {
  /** User email. Used when auth claims are unavailable */
  userEmail?: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type GetApiWorkspacesMeProjectCountsApiResponse =
  /** status 200 OK */ { data: WorkspaceListWorkspaceProjectCountsResponse };
export type GetApiWorkspacesMeProjectCountsApiArg = {
  /** User email. Used when auth claims are unavailable */
  userEmail?: string;
};
export type GetApiWorkspacesByIdApiResponse =
  /** status 200 OK */ { data: WorkspaceWorkspaceResponse };
export type GetApiWorkspacesByIdApiArg = {
  /** Workspace ID */
  id: string;
};
export type DeleteApiWorkspacesByIdApiResponse = unknown;
export type DeleteApiWorkspacesByIdApiArg = {
  /** Workspace ID */
  id: string;
};
export type PatchApiWorkspacesByIdApiResponse =
  /** status 200 OK */ { data: WorkspaceWorkspaceResponse };
export type PatchApiWorkspacesByIdApiArg = {
  /** Workspace ID */
  id: string;
  /** Workspace update request */
  workspaceUpdateWorkspaceRequest: WorkspaceUpdateWorkspaceRequest;
};
export type GetApiWorkspacesByIdInvitationsApiResponse =
  /** status 200 OK */ { data: WorkspacePendingWorkspaceInvitationResponse[] };
export type GetApiWorkspacesByIdInvitationsApiArg = {
  /** Workspace ID */
  id: string;
};
export type DeleteApiWorkspacesByIdInvitationsAndInvitationIdApiResponse =
  unknown;
export type DeleteApiWorkspacesByIdInvitationsAndInvitationIdApiArg = {
  /** Workspace ID */
  id: string;
  /** Invitation ID */
  invitationId: string;
};
export type PostApiWorkspacesByIdLeaveApiResponse =
  /** status 200 OK */ { data: WorkspaceLeaveResult };
export type PostApiWorkspacesByIdLeaveApiArg = {
  /** Workspace ID */
  id: string;
  /** New owner to hand ownership to */
  workspaceLeaveRequest: WorkspaceLeaveRequest;
};
export type GetApiWorkspacesByIdLeavePreviewApiResponse =
  /** status 200 OK */ { data: WorkspaceLeavePreview };
export type GetApiWorkspacesByIdLeavePreviewApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiWorkspacesByIdMembersApiResponse =
  /** status 200 OK */ { data: WorkspaceListWorkspaceMembersResponse };
export type GetApiWorkspacesByIdMembersApiArg = {
  /** Workspace ID */
  id: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type PostApiWorkspacesByIdMembersApiResponse =
  /** status 201 Created */ WorkspaceAddMemberResponse;
export type PostApiWorkspacesByIdMembersApiArg = {
  /** Workspace ID */
  id: string;
  /** Add member by email request */
  workspaceAddMemberRequest: WorkspaceAddMemberRequest;
};
export type WorkspaceGetMembersIdpSubsApiResponse =
  /** status 200 OK */ { data: WorkspaceMemberIdpSubResponse[] };
export type WorkspaceGetMembersIdpSubsApiArg = {
  /** Workspace ID */
  id: string;
};
export type DeleteApiWorkspacesByIdMembersAndUserIdApiResponse = unknown;
export type DeleteApiWorkspacesByIdMembersAndUserIdApiArg = {
  /** Workspace ID */
  id: string;
  /** User ID */
  userId: string;
};
export type GetApiWorkspacesByIdMembersAndUserIdRoleApiResponse =
  /** status 200 OK */ { data: WorkspaceMemberRoleResponse };
export type GetApiWorkspacesByIdMembersAndUserIdRoleApiArg = {
  /** Workspace ID */
  id: string;
  /** User ID */
  userId: string;
};
export type PatchApiWorkspacesByIdMembersAndUserIdRoleApiResponse =
  /** status 200 OK */ WorkspaceUpdateMemberRoleResponse;
export type PatchApiWorkspacesByIdMembersAndUserIdRoleApiArg = {
  /** Workspace ID */
  id: string;
  /** User ID */
  userId: string;
  /** Update member role request */
  workspaceUpdateWorkspaceMemberRoleRequest: WorkspaceUpdateWorkspaceMemberRoleRequest;
};
export type GetApiWorkspacesByIdOwnerApiResponse =
  /** status 200 OK */ { data: WorkspaceWorkspaceOwnerResponse };
export type GetApiWorkspacesByIdOwnerApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiWorkspacesByIdPermissionsApiResponse =
  /** status 200 OK */ WorkspaceMyPermissionsResponse;
export type GetApiWorkspacesByIdPermissionsApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiWorkspacesByIdSshKeyApiResponse =
  /** status 200 OK */ { data: EtlSourceGetWorkspaceSshKeyResponse };
export type GetApiWorkspacesByIdSshKeyApiArg = {
  /** Workspace ID */
  id: string;
};
export type PostApiWorkspacesByIdSshKeyApiResponse =
  /** status 200 OK */ { data: EtlSourceProvisionWorkspaceSshKeyResponse };
export type PostApiWorkspacesByIdSshKeyApiArg = {
  /** Workspace ID */
  id: string;
};
export type WorkspaceReportSettingsResponse = ReportSettingsResponse;
export type WorkspaceWorkspaceResponse = WorkspaceResponse;
export type WorkspaceListWorkspacesResponse = ListWorkspacesResponse;
export type WorkspaceCreateWorkspaceRequest = {
  index_color?: number;
  name: string;
  owner_user_id?: string;
  subscription_tier: string;
};
export type WorkspaceWorkspaceProjectCountItem = WorkspaceProjectCountItem;
export type WorkspaceListWorkspaceProjectCountsResponse = ListWorkspaceProjectCountsResponse;
export type WorkspaceReportSettingsPayload = {
  alert_on_broken?: boolean;
  bi_digest_enabled?: boolean;
  bi_digest_recipients?: string[];
  language?: "es" | "en";
  recipients?: string[];
};
export type WorkspaceUpdateWorkspaceRequest = {
  index_color?: number;
  name?: string;
  report?: WorkspaceReportSettingsPayload;
  subscription_tier?: string;
  /** TrialEndsAt moves a Free workspace's expiry; admin only (PATCH /api/admin/workspaces/{id}/plan),
    like the tier. The
    zero time clears the date, and the sweeper starts a full trial again on its next
    tick once the workspace has a source. A workspace whose trial ended sits on
    trial-expired, so moving or restarting its trial takes subscription_tier: free in
    the same request. */
  trial_ends_at?: string;
};
export type WorkspacePendingWorkspaceInvitationResponse = PendingWorkspaceInvitationResponse;
export type WorkspaceLeaveResult = LeaveResult;
export type WorkspaceLeaveRequest = {
  new_owner_user_id?: string;
};
export type WorkspaceWorkspaceMemberResponse = WorkspaceMemberResponse;
export type WorkspaceLeavePreview = LeavePreview;
export type WorkspaceListWorkspaceMembersResponse = ListWorkspaceMembersResponse;
export type WorkspaceAddMemberResponse = AddMemberResponse;
export type WorkspaceAddMemberRequest = {
  /** AcceptExtraSeat is an owner's answer to SEAT_NOT_INCLUDED: yes, add this person
    even though the seat is billed. Ignored while the org is within its included seats. */
  accept_extra_seat?: boolean;
  email: string;
  /** Role to assign on invite. Defaults to "member" when empty. */
  role?: "owner" | "admin" | "member" | "readonly";
};
export type WorkspaceMemberIdpSubResponse = MemberIdpSubResponse;
export type WorkspaceMemberRoleResponse = MemberRoleResponse;
export type WorkspaceUpdateMemberRoleResponse = UpdateMemberRoleResponse;
export type WorkspaceUpdateWorkspaceMemberRoleRequest = {
  role: "owner" | "admin" | "member" | "readonly";
};
export type WorkspaceWorkspaceOwnerResponse = WorkspaceOwnerResponse;
export type PermissionPermission = Permission;
export type WorkspaceMyPermissionsResponse = MyPermissionsResponse;
export type EtlSourceGetWorkspaceSshKeyResponse = GetWorkspaceSSHKeyResponse;
export type EtlSourceProvisionWorkspaceSshKeyResponse = ProvisionWorkspaceSSHKeyResponse;
export const {
  useGetApiWorkspacesQuery,
  useLazyGetApiWorkspacesQuery,
  usePostApiWorkspacesMutation,
  useGetApiWorkspacesMeQuery,
  useLazyGetApiWorkspacesMeQuery,
  useGetApiWorkspacesMeProjectCountsQuery,
  useLazyGetApiWorkspacesMeProjectCountsQuery,
  useGetApiWorkspacesByIdQuery,
  useLazyGetApiWorkspacesByIdQuery,
  useDeleteApiWorkspacesByIdMutation,
  usePatchApiWorkspacesByIdMutation,
  useGetApiWorkspacesByIdInvitationsQuery,
  useLazyGetApiWorkspacesByIdInvitationsQuery,
  useDeleteApiWorkspacesByIdInvitationsAndInvitationIdMutation,
  usePostApiWorkspacesByIdLeaveMutation,
  useGetApiWorkspacesByIdLeavePreviewQuery,
  useLazyGetApiWorkspacesByIdLeavePreviewQuery,
  useGetApiWorkspacesByIdMembersQuery,
  useLazyGetApiWorkspacesByIdMembersQuery,
  usePostApiWorkspacesByIdMembersMutation,
  useWorkspaceGetMembersIdpSubsQuery,
  useLazyWorkspaceGetMembersIdpSubsQuery,
  useDeleteApiWorkspacesByIdMembersAndUserIdMutation,
  useGetApiWorkspacesByIdMembersAndUserIdRoleQuery,
  useLazyGetApiWorkspacesByIdMembersAndUserIdRoleQuery,
  usePatchApiWorkspacesByIdMembersAndUserIdRoleMutation,
  useGetApiWorkspacesByIdOwnerQuery,
  useLazyGetApiWorkspacesByIdOwnerQuery,
  useGetApiWorkspacesByIdPermissionsQuery,
  useLazyGetApiWorkspacesByIdPermissionsQuery,
  useGetApiWorkspacesByIdSshKeyQuery,
  useLazyGetApiWorkspacesByIdSshKeyQuery,
  usePostApiWorkspacesByIdSshKeyMutation,
} = injectedRtkApi;
